import './Cta.scss';

import React from 'react';

import { Button, Column, GridContainer, Icon, P, Row } from '@vp/swan';

import {
  WIX_TERMS_OF_USE_PAGER_URL,
  WIX_PRIVACY_POLICY_PAGER_URL,
} from '@vp/digital-url-service-lib';
import { TextBlockModel } from '@vp/digital-common-data-model-lib';
import { TokenReplacer, LinkFactory } from '@vp/digital-token-replacer-lib';

import {
  GET_STARTED_CTA_DETAIL,
  FREE_WEBSITES_SECTION_DATA_SECTION_LABEL,
} from '../WixWebsitesAnalytics';
import MissingContentAlert from '../../common/MissingContentAlert';

type HowToCreateCtaProps = {
  content?: TextBlockModel;
  primaryCtaClick: Function;
};

function HowToCreateCta({
  content,
  primaryCtaClick,
}: HowToCreateCtaProps): JSX.Element {
  if (!content) {
    return <MissingContentAlert />;
  }

  return (
    <GridContainer>
      <Row>
        <Column span={12} textAlign="center" darkMode>
          <Button
            skin="primary"
            data-position="6"
            data-section={FREE_WEBSITES_SECTION_DATA_SECTION_LABEL}
            data-translation={GET_STARTED_CTA_DETAIL}
            className="wix-websites-pdp__cta"
            onClick={() => {
              primaryCtaClick();
            }}
          >
            {content.title}

            <Icon iconType="arrowRight" />
          </Button>
        </Column>

        <Column
          span={8}
          offset={2}
          spanLg={6}
          offsetLg={3}
          spanXl={6}
          offsetXl={3}
        >
          <P textAlign="center" fontSize="xsmall" textColor="info" mb={0}>
            <TokenReplacer
              template={content.description}
              replacements={{
                link: LinkFactory({
                  wixTermsOfUsePagerUrl: WIX_TERMS_OF_USE_PAGER_URL,
                  wixPrivacyPolicyPagerUrl: WIX_PRIVACY_POLICY_PAGER_URL,
                }),
              }}
              convertMarkdown
            />
          </P>
        </Column>
      </Row>
    </GridContainer>
  );
}

export default HowToCreateCta;
